export const calculateFinancedAmount = (
  amount,
  downPayment
) => {
  return parseFloat(amount.replace(/,/g, '')) - parseInt(downPayment);
};

export const calculateMonthlyInstallment = (
  amount,
  downPayment,
  months,
  interestRate
) => {
  const principal =
    parseFloat(amount.replace(/,/g, '')) - parseInt(downPayment);
  const loan_interest = principal * (interestRate / (12 / months) / 100);
  const sum_of_installments = loan_interest + principal;
  const monthly_installment = Math.round(sum_of_installments / months);
  return monthly_installment;
};

export const calculateAdminFees = (
  amount,
  adminFeesPercentage,
  downPayment
) => {
  return Math.round(
    (parseFloat(amount.replace(/,/g, '')) - parseInt(downPayment)) *
      (adminFeesPercentage / 100)
  );
};
